import React from "react";

import rewards0 from "@pages/learn/assets/advanced/advanced1.png";
import rewards1 from "@pages/learn/assets/advanced/advanced2.png";
import rewards2 from "@pages/learn/assets/advanced/advanced3.png";
import rewards3 from "@pages/learn/assets/advanced/advanced4.png";
import rewards4 from "@pages/learn/assets/advanced/advanced5.png";
import rewards5 from "@pages/learn/assets/advanced/advanced6.png";
import rewards6 from "@pages/learn/assets/advanced/advanced7.png";

const rewardsheight = "225px";
const text = "incomplete puzzle";

export const ADVANCED_REWARDS: React.ReactNode[] = [
  <img
    className="image"
    src={rewards0}
    height={rewardsheight}
    alt="empty puzzle"
  ></img>,
  <img
    className="image"
    src={rewards1}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards2}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards3}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards4}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards5}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards6}
    height={rewardsheight}
    alt={text}
  ></img>,
];
